module.exports = __webpack_public_path__ + "static/media/feature.4091145e.jpg";